import { Stack } from 'expo-router';

import { getScreenTitleHeader } from '../../components/get-screen-title-header';

/** Stable component identity for React Navigation — do not call getScreenTitleHeader() inside render. */
const drawerAccountStackHeader = getScreenTitleHeader({
  backStyle: 'back',
  cannotGoBackHref: '/account',
});
export default function DrawerLayout() {
  return (
    <Stack
      screenOptions={{
        header: drawerAccountStackHeader,
      }}
    >
      <Stack.Screen
        name="account/info"
        options={{
          title: 'My Account',
        }}
      />
      <Stack.Screen
        name="account/payment"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="account/gift-cards"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="diagnostics"
        options={{
          title: 'Diagnostics',
        }}
      />
    </Stack>
  );
}
